import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import { Menu, X } from "lucide-react";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = async () => {
    await logout();
    navigate('/');
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-card shadow-md sticky top-0 z-50">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="text-lg md:text-2xl font-bold text-primary whitespace-nowrap">
            Nézd.Át Nekem!
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-4">
            <Link to="/discounts">
              <Button variant="ghost" size="sm">Akciós lista</Button>
            </Link>
            {user?.loggedIn && user?.isAdmin && (
              <Link to="/admin">
                <Button variant="ghost" size="sm">Admin</Button>
              </Link>
            )}
          </div>

          {/* Desktop Auth */}
          <div className="hidden md:flex items-center gap-4">
            {user?.loggedIn ? (
              <>
                <span className="text-sm text-muted-foreground truncate max-w-[150px]">{user.email}</span>
                <Button variant="outline" size="sm" onClick={handleLogout}>
                  Kijelentkezés
                </Button>
              </>
            ) : (
              <Link to="/auth">
                <Button size="sm">Belépés</Button>
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 text-foreground"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 space-y-3 pb-4 border-t border-border pt-4">
            <Link
              to="/discounts"
              onClick={() => setIsMenuOpen(false)}
              className="block px-4 py-2 text-foreground hover:bg-primary/10 rounded-md transition-colors"
            >
              Akciós lista
            </Link>
            {user?.loggedIn && user?.isAdmin && (
              <Link
                to="/admin"
                onClick={() => setIsMenuOpen(false)}
                className="block px-4 py-2 text-foreground hover:bg-primary/10 rounded-md transition-colors"
              >
                Admin
              </Link>
            )}
            <div className="border-t border-border pt-3">
              {user?.loggedIn ? (
                <>
                  <div className="px-4 py-2 text-sm text-muted-foreground truncate">
                    {user.email}
                  </div>
                  <button
                    onClick={handleLogout}
                    className="w-full text-left px-4 py-2 text-foreground hover:bg-primary/10 rounded-md transition-colors"
                  >
                    Kijelentkezés
                  </button>
                </>
              ) : (
                <Link
                  to="/auth"
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-4 py-2 text-foreground hover:bg-primary/10 rounded-md transition-colors"
                >
                  Belépés
                </Link>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;